import { useMutation } from "@shared/lib/hooks";
import { useCallback } from "react";

import { BRAND_LIST_QUERY_KEY } from "@entities/brand/lib/constants";
import { ToastService } from "@shared/lib/services";
import { ORGANISATION_BRANDS_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";
import { ICreateBrandRequest } from "../types";

const QUERY_OPTIONS = {
  queryKey: BRAND_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useCreateBrand(handleSuccess?: () => void) {
  const createBrand = useCallback(
    (brand: ICreateBrandRequest) =>
      OrganisationService.createBrand(brand).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateBrandRequest>({
    mutationFn: createBrand,
    options: QUERY_OPTIONS,
    onSuccess: (c, _, params) => {
      c.invalidateQueries({
        queryKey: [
          ...ORGANISATION_BRANDS_QUERY_KEY,
          params.brandOrganisationId,
        ],
      });
      if (handleSuccess) {
        handleSuccess();
      }
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
